import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { DomSanitizer } from "@angular/platform-browser";
import { contractAddress } from 'app/services/contract/contract.config';
import { Web3Service } from 'app/services/web3/web3.service';

@Component({
  selector: 'app-breeding-center',
  templateUrl: './breeding-center.component.html',
  styleUrls: ['./breeding-center.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BreedingCenterComponent implements OnInit {

  deeplink;
  kmonNFTv2Address: string;

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private web3Service: Web3Service) {
  }

  ngOnInit(): void {
    this.kmonNFTv2Address = contractAddress[this.web3Service.getNetworkName()].KMONFTV2;
    this.route.params.subscribe((params: Params) => {
      this.deeplink = params['id']
      if (this.deeplink == undefined || this.deeplink == '') {
        this.deeplink = this.sanitizer.bypassSecurityTrustResourceUrl("https://market.kryptomon.co/breed/contracts/undefined/tokens/undefined")
        console.log(this.deeplink)
      } else {
        this.deeplink = this.sanitizer.bypassSecurityTrustResourceUrl("https://market.kryptomon.co/breed/contracts/" + this.kmonNFTv2Address + "/tokens/" + params['id'])
        console.log(this.deeplink)
      }
    });
  }

}
